export default __webpack_public_path__ + "media/images/preview-6ffea616e3733ad70192afbba023af4a.png";